import AbstractPopup from "./AbstractPopup";
import Button from "../../views/components/Button";
import ViewManager from "../../utils/ViewManager";
import { DefaultLayers } from "../../utils/Layers";
import PointerEvents from "../../const/PointerEvents";
import TextField from "../../views/components/TextField";
import Locale from "../../utils/Locale";
import SoundVars from '../../const/SoundVars';
import SoundController from '../../utils/SoundController';

export default class MessagePopup extends AbstractPopup {
    public title: TextField;
    public text: TextField;
    public closeBtn: Button;

    constructor() {
        super();
        this.layer = ViewManager.getLayer(DefaultLayers.Popups);
    }

    public show(callback?: Function) {
        super.show();
        ViewManager.getLayer(DefaultLayers.SplashOverlay).setScene("open");
        this.scene = this.layer.setScene('message_box');
        this.scene.interactive = true;
        this.closeBtn = this.scene.buttons.get("exit") || this.scene.buttons.get("close");
        this.text = this.scene.sceneTextFields.get('text') as TextField;
        this.title = this.scene.sceneTextFields.get('title') as TextField;

        this.closeBtn.once(PointerEvents.DOWN, (e) => {
            e.stopPropagation();
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            if (callback) {
                callback();
            }

            ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
            this.hide();
        });
    }

    public setText(value: string) {
        this.text.text = value;
    }

    public setTitle(value: string) {
        this.title.text = value;
    }

    protected hideFromKeyboard() {

    }
}
